module.exports = __webpack_public_path__ + "img/iceland.f4178f5e.svg";